(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jd1-featured-collection-os"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const getVisibleCount = (slider) => {
      const first = slider.querySelector('.jd1-fc__item');
      if (!first) return 1;
      const itemWidth = first.getBoundingClientRect().width;
      if (!itemWidth) return 1;
      const raw = slider.clientWidth / itemWidth;
      return Math.max(1, Math.floor(raw));
    };

    const hardReset = (slider) => {
      slider.scrollLeft = 0;
      requestAnimationFrame(() => {
        slider.scrollLeft = 0;
      });
      setTimeout(() => {
        slider.scrollLeft = 0;
      }, 120);
      setTimeout(() => {
        slider.scrollLeft = 0;
      }, 320);
    };

    const bindDrag = (slider) => {
      if (slider.dataset.jd1DragBound) return;
      slider.dataset.jd1DragBound = 'true';

      let isDown = false;
      let startX = 0;
      let startLeft = 0;
      let dragged = false;

      const interactiveSelector = 'a, button, input, select, textarea, summary, label, [role="button"], [data-product-card-link], product-form, quick-add, .quick-add, .pf-fav-trigger';

      slider.addEventListener('pointerdown', (event) => {
        if (event.button !== undefined && event.button !== 0) return;

        // Click-safe: product links, quick add, favorite, labels and buttons keep their native click.
        // Drag still works from non-interactive card areas.
        if (event.target.closest(interactiveSelector)) return;

        isDown = true;
        dragged = false;
        startX = event.clientX;
        startLeft = slider.scrollLeft;
        slider.classList.add('is-dragging');
        slider.setPointerCapture?.(event.pointerId);
      });

      slider.addEventListener('pointermove', (event) => {
        if (!isDown) return;
        const dx = event.clientX - startX;
        if (Math.abs(dx) > 8) dragged = true;
        if (dragged) slider.scrollLeft = startLeft - dx;
      });

      const endDrag = (event) => {
        if (!isDown) return;
        isDown = false;
        slider.classList.remove('is-dragging');
        slider.releasePointerCapture?.(event.pointerId);
      };

      slider.addEventListener('pointerup', endDrag);
      slider.addEventListener('pointercancel', endDrag);
      slider.addEventListener('pointerleave', endDrag);

      slider.addEventListener('click', (event) => {
        if (!dragged) return;
        event.preventDefault();
        event.stopPropagation();
        dragged = false;
      }, true);
    };

    const initSlider = (slider, forceReset = false) => {
      const section = slider.closest('.jd1-fc');
      if (!slider.classList.contains('jd1-fc__items--slider')) return;
      if (!slider.querySelector('.jd1-fc__item')) return;

      bindDrag(slider);

      if (!section || section.dataset.jd1Dots !== 'true') return;

      let dots = slider.nextElementSibling;
      if (!dots || !dots.classList.contains('jd1-fc__dots')) {
        dots = document.createElement('div');
        dots.className = 'jd1-fc__dots';
        dots.setAttribute('aria-label', 'Slider pagination');
        slider.insertAdjacentElement('afterend', dots);
      }

      const items = Array.from(slider.querySelectorAll('.jd1-fc__item'));
      const visible = getVisibleCount(slider);
      const count = Math.max(1, Math.ceil(items.length / visible));

      dots.innerHTML = '';

      if (count <= 1) {
        dots.hidden = true;
      } else {
        dots.hidden = false;
      }

      const setActive = () => {
        const first = items[0];
        if (!first) return;
        const itemStep = (items[visible]?.offsetLeft || (first.offsetLeft + first.getBoundingClientRect().width + 1)) - first.offsetLeft;
        const current = itemStep > 0 ? Math.round(slider.scrollLeft / itemStep) : 0;

        dots.querySelectorAll('.jd1-fc__dot').forEach((dot, index) => {
          dot.classList.toggle('is-active', index === current);
          dot.setAttribute('aria-current', index === current ? 'true' : 'false');
        });
      };

      for (let i = 0; i < count; i += 1) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'jd1-fc__dot';
        dot.setAttribute('aria-label', `Ir al grupo ${i + 1}`);
        dot.addEventListener('click', () => {
          const target = items[i * visible] || items[items.length - 1];
          slider.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
        });
        dots.appendChild(dot);
      }

      if (!slider.dataset.jd1Bound) {
        slider.dataset.jd1Bound = 'true';
        slider.addEventListener('scroll', setActive, { passive: true });
      }

      if (!slider.dataset.jd1Reset || forceReset) {
        slider.dataset.jd1Reset = 'true';
        hardReset(slider);
      }

      setActive();
    };

    const initAll = (root = document, forceReset = false) => {
      root.querySelectorAll('.jd1-fc__items--slider').forEach((slider) => initSlider(slider, forceReset));
    };

    const schedule = (root = document, forceReset = false) => {
      requestAnimationFrame(() => initAll(root, forceReset));
      setTimeout(() => initAll(root, forceReset), 160);
      setTimeout(() => initAll(root, forceReset), 420);
    };

    schedule(document, true);

    document.addEventListener('shopify:section:load', (event) => schedule(event.target, true));
    document.addEventListener('shopify:block:select', (event) => schedule(event.target, true));
    document.addEventListener('change', (event) => {
      if (event.target.matches('.jd1-fc__tab-input')) {
        const section = event.target.closest('.jd1-fc');
        section?.querySelectorAll('.jd1-fc__items--slider').forEach((slider) => {
          slider.dataset.jd1Reset = '';
        });
        schedule(section, true);
      }
    });

    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => schedule(document, false), 160);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jd1-shop-the-gram"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-jd1-stg]');

    roots.forEach((root) => {
      if (root.dataset.stgBound === 'true') return;
      root.dataset.stgBound = 'true';

      const modal = root.querySelector('[data-stg-modal]');
      const items = Array.from(root.querySelectorAll('[data-stg-modal-item]'));
      let current = 0;

      const setActive = (index) => {
        if (!items.length) return;
        current = (index + items.length) % items.length;
        items.forEach((item, itemIndex) => {
          item.classList.toggle('is-active', itemIndex === current);
        });
      };

      const openModal = (index) => {
        if (!modal || !items.length) return;
        setActive(index);
        modal.hidden = false;
        document.documentElement.classList.add('jd1-stg-modal-open');
      };

      const closeModal = () => {
        if (!modal) return;
        modal.hidden = true;
        document.documentElement.classList.remove('jd1-stg-modal-open');
        root.querySelectorAll('.jd1-stg__product-pop.is-active').forEach((pop) => pop.classList.remove('is-active'));
      };

      const toggleHotspot = (button) => {
        const key = button.getAttribute('data-stg-hotspot');
        const scope = button.closest('.jd1-stg__post, .jd1-stg__modal-media') || root;
        scope.querySelectorAll('.jd1-stg__product-pop').forEach((pop) => {
          pop.classList.toggle('is-active', pop.getAttribute('data-stg-product-panel') === key);
        });
        const activeItem = button.closest('.jd1-stg__modal-item');
        if (activeItem) {
          activeItem.querySelectorAll('.jd1-stg__side-product').forEach((card) => {
            card.classList.toggle('is-active', card.getAttribute('data-stg-product-card') === key);
          });
        }
      };

      root.addEventListener('click', (event) => {
        const hotspot = event.target.closest('[data-stg-hotspot]');
        if (hotspot && root.contains(hotspot)) {
          event.preventDefault();
          event.stopPropagation();
          toggleHotspot(hotspot);
          return;
        }

        if (event.target.closest('a')) return;

        if (event.target.closest('[data-stg-close]')) {
          closeModal();
          return;
        }

        if (event.target.closest('[data-stg-prev]')) {
          setActive(current - 1);
          return;
        }

        if (event.target.closest('[data-stg-next]')) {
          setActive(current + 1);
          return;
        }

        if (event.target === modal) {
          closeModal();
          return;
        }

        const opener = event.target.closest('[data-stg-open]');
        if (opener && root.contains(opener)) {
          openModal(Number(opener.dataset.stgIndex || 0));
        }
      });

      document.addEventListener('keydown', (event) => {
        if (!modal || modal.hidden) return;
        if (event.key === 'Escape') closeModal();
        if (event.key === 'ArrowLeft') setActive(current - 1);
        if (event.key === 'ArrowRight') setActive(current + 1);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pf-hero-slideshow"] && !Shopify.designMode) return;
  try {
    
  class PfHeroSlider extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.slides = Array.from(this.querySelectorAll('[data-pf-slide]'));
      this.prevButton = this.querySelector('[data-pf-prev]');
      this.nextButton = this.querySelector('[data-pf-next]');
      this.dotsContainer = this.querySelector('[data-pf-dots]');
      this.index = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
      this.autoplay = this.dataset.autoplay === 'true';
      this.speed = Number(this.dataset.speed || 5000);
      this.pauseOnHover = this.dataset.pauseOnHover === 'true';
      this.timer = null;

      this.renderDots();
      this.goTo(this.index, false);
      this.bindEvents();
      this.start();
    }

    disconnectedCallback() {
      this.stop();
    }

    bindEvents() {
      this.prevButton?.addEventListener('click', () => this.goTo(this.index - 1));
      this.nextButton?.addEventListener('click', () => this.goTo(this.index + 1));

      if (this.pauseOnHover) {
        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', () => this.start());
      }

      document.addEventListener('shopify:block:select', (event) => {
        const slide = event.target?.closest?.('[data-pf-slide]');
        if (!slide || !this.contains(slide)) return;
        const nextIndex = this.slides.indexOf(slide);
        if (nextIndex >= 0) {
          this.stop();
          this.goTo(nextIndex);
        }
      });
    }

    renderDots() {
      if (!this.dotsContainer || this.slides.length <= 1) return;
      this.dotsContainer.innerHTML = '';
      this.dots = this.slides.map((slide, index) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'pf-hero__dot';
        dot.setAttribute('aria-label', `Ir al slide ${index + 1}`);
        dot.addEventListener('click', () => this.goTo(index));
        this.dotsContainer.append(dot);
        return dot;
      });
    }

    goTo(nextIndex, shouldRestart = true) {
      if (!this.slides.length) return;
      const total = this.slides.length;
      this.index = ((nextIndex % total) + total) % total;

      this.slides.forEach((slide, index) => {
        const active = index === this.index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });

      this.dots?.forEach((dot, index) => {
        dot.classList.toggle('is-active', index === this.index);
        dot.setAttribute('aria-current', index === this.index ? 'true' : 'false');
      });

      if (shouldRestart) {
        this.stop();
        this.start();
      }
    }

    start() {
      if (!this.autoplay || this.slides.length <= 1) return;
      this.stop();
      this.timer = window.setInterval(() => this.goTo(this.index + 1, false), this.speed);
    }

    stop() {
      if (!this.timer) return;
      window.clearInterval(this.timer);
      this.timer = null;
    }
  }

  if (!customElements.get('pf-hero-slider')) {
    customElements.define('pf-hero-slider', PfHeroSlider);
  }

  } catch(e) { console.error(e); }
})();
})();
